import { render } from "./AdditionalInfoModal.vue?vue&type=template&id=7df891b0&scoped=true"
import script from "./AdditionalInfoModal.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoModal.vue?vue&type=script&lang=js"

import "./AdditionalInfoModal.vue?vue&type=style&index=0&id=7df891b0&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df891b0"]])

export default __exports__